angular.module('filters.lists', [])
  .filter('pluck', function () {
    return function (input, field) {
      return _.map(
        input || [],
        function(obj) {
          return obj[field];
        }
      );
    };
  })

  .filter('joinBy', function () {
    return function (input, delimiter) {
      return (input || []).join(delimiter || ',');
    };
  });
